import { Link } from 'react-router-dom';
import { styled } from '../Stitches';

export const LinkText = styled(Link, {
  '&:hover': {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
});
